import AppModule from "@/app/modules/module";
import Guards from '@/app/middleware/guards'
import {authManager, webManager,authManagerCheckProfile,authManagerCheckPayment} from '@/app/middleware/register'

export default new AppModule('c-project')
    .routers([
        {
            path: '/company/',
            component: AppModule.layout.CompanyLayout,
            beforeEnter: Guards([webManager,authManager,authManagerCheckProfile,authManagerCheckPayment]),
            children: [
                {
                    path: 'register/project/copy/:id',
                    name: 'manager.register.project.id',
                    component: () => import('./views/copy-project'),
                    meta: {
                        title: '新規案件登録',
                        bodyClass: ''
                    }
                },
                {
                    path: 'register/project',
                    name: 'manager.register.project',
                    component: () => import('./views/register-project'),
                    meta: {
                        title: '新規案件登録',
                        bodyClass: ''
                    }
                },
                {
                    path: 'detail/project/:id',
                    name: 'manager.detail.project',
                    component: () => import('./views/detail-project'),
                    meta: {
                        title: '詳細プロジェクト',
                        bodyClass: ''
                    }
                }
            ]
        },
    ])
    .register()
